/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'textview': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M113.168 33.332H36.832a3.52 3.52 0 0 0-3.5 3.5v76.418a3.52 3.52 0 0 0 3.5 3.5h76.418a3.52 3.52 0 0 0 3.5-3.5V36.832c-.082-1.914-1.668-3.5-3.582-3.5zm-3.418 76.418h-69.5v-69.5h69.418v69.5h.082z"/><rect pid="1" x="48" y="50" width="55" height="7" rx="1"/><rect pid="2" x="48" y="94" width="55" height="7" rx="1"/><rect pid="3" x="48" y="61" width="55" height="7" rx="1"/><rect pid="4" x="48" y="72" width="55" height="7" rx="1"/><rect pid="5" x="48" y="83" width="36" height="7" rx="1"/></g>'
  }
})
